export const getRootTag = (tag, contentTagsMapById) => {
  const parentTag = contentTagsMapById[tag?.parentId];
  if (!parentTag) {
    return tag;
  }

  return getRootTag(parentTag, contentTagsMapById);
};
